var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sectionName != null)?_c('b-badge',{staticClass:"mr-2",attrs:{"variant":"light"}},[_vm._v("\n    "+_vm._s(_vm.sectionName)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }